import { useLocalSearchParams } from 'expo-router';

import { HandoffDetail } from '@/components/pages/handoff';
import { parseHandoffIdParam } from '@/models/handoffRouteParams';

const HandoffDetailRoute = () => {
  const { id } = useLocalSearchParams<{ id: string }>();
  const handoffId = parseHandoffIdParam(id);

  return handoffId ? <HandoffDetail id={handoffId} /> : null;
};

export default HandoffDetailRoute;
